console.log("PagePilot initialized");

const pagepilot = {
  init: function () {
    console.log("PagePilot initialized!");
  },
  scrollToElement: function (scrollElement = null) {
    targetElement = null;

    if (scrollElement) {
      scrollElement = scrollElement.replace(/([\[\]])/g, "\\$1");
      console.log(scrollElement);
      targetElement = document.querySelector(`${scrollElement}`);
    }

    if (!targetElement) {
      const classNames = [
        "variant-selects",
        ".product-single__form",
        ".variant-wrapper",
        ".product-form",
        ".product__section--qty",
        ".product-form__input--pill",
        ".quantity-wrapper",
        ".variant-quantity-wrapper",
        ".variants-select-wrapper",
        ".add-to-cart",
        ".atc",
        ".addtocart",
        ".add-to-cart-button",
        ".product-add-to-cart",
        ".ProductAddToCart",
        ".product-submit",
        ".product-form__item--quantity",
        ".buy-now-button",
        ".BuyNowButton",
        ".product-buy-buttons",
        ".AddToCartForm",
        ".AddToCartText",
        "#AddToCartForm-product-template",
        "#product-form",
        "#product-info",
        "#main-product-content",
        "#AddToCart",
        "#new-form-atc",
        "#AddToCartButton",
        "#add-to-cart-button",
        "#product-add-to-cart",
        "#ProductAddToCart",
        "#product-submit",
        "#buy-now-button",
        "#BuyNowButton",
        "#product-buy-buttons",
        "#AddToCartForm",
        "#AddToCartText",
        "#ProductSelect-product-template",
        "#ProductSubmitButton",
        "#ProductSubmitButtonText",
        "#ProductPrice-product-template",
      ];

      for (let className of classNames) {
        targetElement = document.querySelector(`${className}`);
        if (targetElement) break;
      }
    }

    const offset = 250;

    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        window.scrollTo(0, elementPosition - offset);
      } else {
        window.scrollTo({
          top: elementPosition - offset,
          behavior: "smooth",
        });
      }
    } else {
      // If no element found, scroll to the top of the page
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  },
};

document.addEventListener("DOMContentLoaded", pagepilot.init);


let currentImageIndex = 0;
let images = [];

document.addEventListener("click", function(event) {
  // Verifică dacă imaginea are clasele specificate pentru imaginile din recenzii
  if (event.target.classList.contains("pp-w-full") &&
      event.target.classList.contains("pp-h-full") &&
      event.target.classList.contains("pp-max-w-full")) {
      
    images = Array.from(document.querySelectorAll(".pp-w-full.pp-h-full.pp-max-w-full"));
    currentImageIndex = images.indexOf(event.target);
    
    openModal(images[currentImageIndex].src);
  }
});

function openModal(imageSrc) {
  const modal = document.getElementById("imageModal");
  const modalImg = document.getElementById("modalImage");

  modal.style.display = "block";
  modalImg.src = imageSrc;
}

function closeModal() {
  document.getElementById("imageModal").style.display = "none";
}

// Funcția de navigare între imagini
function navigateImage(direction) {
  currentImageIndex += direction;

  // Asigură-te că indexul rămâne între limite
  if (currentImageIndex < 0) {
    currentImageIndex = images.length - 1;
  } else if (currentImageIndex >= images.length) {
    currentImageIndex = 0;
  }

  // Actualizează imaginea din modal
  document.getElementById("modalImage").src = images[currentImageIndex].src;
}
document.addEventListener("DOMContentLoaded", function() {
    const reviewsElement = document.querySelector(".pagepilot-reviewsNumber");

    if( reviewsElement ) {
      reviewsElement.addEventListener("click", function() {
          // Găsește elementul care începe cu clasa specificată
          const targetSection = document.querySelector(".pp-flex.pp-gap-1.pp-justify-center");
          if (targetSection) {
              targetSection.scrollIntoView({
                  behavior: "smooth",
                  block: "start" // Asigură scroll-ul la începutul secțiunii
              });
          }
      });
    }
});
